import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Card, Typography } from '@otp/ui';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'src/components/common/router/constants';
import { useDeviceContext } from 'src/context/device.context';
import { ContentWrapper } from '../common/wrapper/content/wrapper';
import { Can } from 'src/utils/can';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

export const AdminSettings = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'admin.settings',
  });

  const { isMobile } = useDeviceContext();

  const navigate = useNavigate();

  return (
    <Can I={Actions.Read} a={Subjects.Admin} appArea={AppArea.Admin}>
      <ContentWrapper>
        <Card noBorder className="flex flex-col w-full bg-white">
          <Typography variant="subtitle1" className="mb-2 font-bold">
            {t('system-settings')}
          </Typography>
          <div
            className={clsx(
              { 'flex-col': isMobile, 'flex-row': !isMobile },
              'flex flex-grow gap-2 mt-4',
            )}
          >
            <Card
              className="flex flex-col h-24 w-auto"
              isLink={true}
              onClick={() => navigate(Routes.wttpConfiguration.path)}
            >
              <Typography variant="subtitle2">
                {t('pages.wttp-configuration')}
              </Typography>
            </Card>
            <Card
              className="flex flex-col h-24 w-auto"
              isLink={true}
              onClick={() => navigate(Routes.roles.path)}
            >
              <Typography variant="subtitle2">
                {t('pages.permission-groups')}
              </Typography>
            </Card>

            <Card
              className="flex flex-col h-24 w-auto"
              isLink={true}
              onClick={() => navigate(Routes.permissions.path)}
            >
              <Typography variant="subtitle2">
                {t('pages.system-permissions')}
              </Typography>
            </Card>
            <Card
              className="flex flex-col h-24 w-auto"
              isLink={true}
              onClick={() => navigate(Routes.userGroups.path)}
            >
              <Typography variant="subtitle2">
                {t('pages.user-groups')}
              </Typography>
            </Card>
          </div>
        </Card>
      </ContentWrapper>
    </Can>
  );
};
